<!--
    file type .....: HTML file: search-medications.component.html
    Created By ....: ianday
    Date ..........: 4/14/25 
-->
<div class="search-medications-container">

    <div class="dwform-instructions">Please enter some information to search on:</div>
    <div class="search-fields-container">
        <div class="dwform">
            <div class="dwform-cell">
              <div class="dwform-row-gap"></div>
                <div class="dwform-row" style="display: inline-block;width:100%;">

                <!-- NDC Number -->
                    <div [hidden]="_callFrom ==='medicationfamily'">
                        <label  class="label-field">NDC Number:</label>
                        <span class="form-required"> </span>
                        <input  mat-input
                               matTooltipPosition="right"
                               (keydown.Enter)="enterPressed($event)"
                               (keyup)="fieldChange($event)"
                               matTooltip="Enter an NDC Number"
                               id="ndcNumber"
                               class="input-field-short"
                               [(ngModel)]="ndcNumber">
                    </div>
                </div>

                <div class="dwform-row-gap"></div>
                <div class="dwform-row">
                <!-- MEDICATION DESCRIPTION  -->
                <label class="label-field">Description:</label>
                <span class="form-required"> </span>
                <input mat-input
                       matTooltipPosition="below"
                       (keydown.Enter)="enterPressed($event)"
                       (keyup)="fieldChange($event)"
                       matTooltip="Medication Description"
                       id="medDescription"
                       style="text-transform: uppercase;"
                       class="input-field-long"
                       [(ngModel)]="medDescription">

                    <div style="display: inline-block; text-align:right; width:10%;">
                        <button class="command-button" tabindex="-1" (click)="resetFields()" style="width:80px;"
                                matTooltip="Clear / Reset fields" mat-button>
                            Reset
                        </button>
                    </div>
                <div class="dwform-row-gap"></div>
            </div>
        </div>
    </div>

    <!----------------------->
    <!-- ERROR LINE --------->
    <!----------------------->
    <div class="error-line" [hidden]='!strErr.length'
         style="text-align:left; bottom:55px; left: 15px;">{{strErr}}</div>
    <!----------------------->
    <!-- SAVE STRIP        -->
    <!----------------------->
    <div style="text-align:center; margin-top: 28px;">

        <button mat-button class="command-button" [disabled]="!enableSubmit"
                (click)="onSubmitClicked()" matTooltip="Search Medication Records"
                mat-button>
            <mat-icon>check_circle_outline</mat-icon>
            Search
        </button>
        <button mat-button class="command-button"
                (click)="onCancelClicked()" matTooltip="Cancel without saving this entry" mat-button>
            <mat-icon>highlight_off</mat-icon>
            Cancel
        </button>
    </div>
</div>
